module.exports = __webpack_public_path__ + "static/media/multiple-pickups.bce78ee5.svg";